/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import specific icons */
import
{
  faAngleDown,
  faArrowDown,
  faArrowDownAZ,
  faArrowDownZA,
  faArrowDownWideShort,
  faArrowUpShortWide,
  faArrowLeft,
  faArrowRight,
  faArrowTurnDownRight as falArrowTurnDownRight,
  faArrowUp,
  faBell,
  faBookmark,
  faBug,
  faBugSlash,
  faBuilding,
  faChartLine,
  faChartLineUp,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsLeft as falChevronsLeft,
  faChevronsRight as falChevronsRight,
  faCircleCheck as falCircleCheck,
  faClockRotateLeft,
  faCode,
  faCodeCompare,
  faCog,
  faCogs,
  faColumns3,
  faCopy,
  faDiagramProject,
  faDownToBracket,
  faEquals,
  faEye,
  faEyeSlash,
  faFile,
  faFileArchive,
  faFileCircleExclamation,
  faFileCode,
  faFileCsv,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFileLines,
  faFileMagnifyingGlass,
  faFilePdf,
  faFileText,
  faFileXls,
  faFileZipper,
  faFilter,
  faFilterSlash,
  faFloppyDisk,
  faGreaterThan,
  faGreaterThanEqual,
  faGripLines,
  faHouse,
  faInfinity,
  faInfoCircle as falInfoCircle,
  faLayerPlus,
  faLessThan,
  faLessThanEqual,
  faListDropdown,
  faLock,
  faMagnifyingGlassChart,
  faMemoCircleCheck,
  faMemoCircleInfo,
  faMinus,
  faMinusCircle,
  faNotEqual,
  faOctagonExclamation,
  faPaperPlane,
  faPencil,
  faPenField,
  faPlay,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faQuestion,
  faQuestionCircle,
  faRectangleList,
  faRotate,
  faRotateRight as falRotateRight,
  faSearch,
  faSearchMinus,
  faDiamondExclamation,
  faSliders,
  faSpinner,
  faSquare,
  faTable,
  faTimes,
  faTrashCan,
  faTrashUndo,
  faTriangleExclamation,
  faUpDownLeftRight,
  faUser,
  faUsers,
  faFolderOpen as falFolderOpen, faListCheck, faList, faBox,
  faFolderCheck, faCabinetFiling, faFolderMagnifyingGlass, faUpFromBracket, faFileArrowUp,
  faUpRightFromSquare, faShieldHalved, faGlobe, faSquarePollHorizontal, faKeySkeleton, faRightLeftLarge, faHourglassHalf,
  faBan, faDatabase, faDownload, faExclamationTriangle, faSave, faStar, faFileEdit,
  faEnvelope as falEnvelope, faEllipsisV, faEllipsisStrokeVertical, faComments,
} from '@fortawesome/pro-light-svg-icons';

import
{
  faArrowRightArrowLeft,
  faCircle,
  faCircleCheck,
  faFolderClosed,
  faFolderOpen,
  faRotateRight as fadRotateRight,
  faToggleLargeOff,
  faToggleLargeOn,
  faWandMagicSparkles,
} from '@fortawesome/pro-duotone-svg-icons';

import
{
  faFolder,
  faSquareCheck,
  faSquareMinus,
  faXmarkLarge,
  faArrowTurnDownRight as fasArrowTurnDownRight,
  faInfoCircle as fasInfoCircle,
  faStar as fasStar
} from '@fortawesome/pro-solid-svg-icons';

/* import font awesome icon component */
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';


// styles
import 'primevue/resources/themes/saga-blue/theme.css'; // theme
import 'primevue/resources/primevue.min.css'; // core css
import 'primeflex/primeflex.css'; // flex
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { initAuth, updateEnvironmentStore, getEnvironmentVariables } from './helpers/auth';

// register globally
// Primevue og dens komponenter
import PrimeVue from 'primevue/config';

// EDIT
import EditSimpleSelect from '@/components/editComponents/editSimpleSelect.vue';
import EditText from '@/components/editComponents/editText.vue';
import EditNumber from '@/components/editComponents/editNumber.vue';
import EditDate from '@/components/editComponents/editDate.vue';
import EditList from '@/components/editComponents/editList.vue';
import EditComment from '@/components/editComponents/editComment.vue';
import EditBool from '@/components/editComponents/editBool.vue';
import EditAutoComplete from '@/components/editComponents/editAutoComplete.vue';
import EditString from '@/components/editComponents/editString.vue';
import EditPercent from '@/components/editComponents/editPercent.vue';
import EditTime from '@/components/editComponents/editTime.vue';


// MENU
import HdrMenuAutoComplete from '@/components/headerMenuComponents/hdrMenuAutoComplete.vue';
import HdrMenuBool from '@/components/headerMenuComponents/hdrMenuBool.vue';
import HdrMenuList from '@/components/headerMenuComponents/hdrMenuList.vue';
import HdrMenuText from '@/components/headerMenuComponents/hdrMenuText.vue';
import HdrMenuSimpleSelect from '@/components/headerMenuComponents/hdrMenuSimpleSelect.vue';
import HdrMenuDate from '@/components/headerMenuComponents/hdrMenuDate.vue';
import HdrMenuNumber from '@/components/headerMenuComponents/hdrMenuNumber.vue';
import HdrMenuString from '@/components/headerMenuComponents/hdrMenuString.vue';
import HdrMenuComment from '@/components/headerMenuComponents/hdrMenuComment.vue';
import HdrMenuPercent from '@/components/headerMenuComponents/hdrMenuPercent.vue';
import HdrMenuTime from '@/components/headerMenuComponents/hdrMenuTime.vue';

import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import JsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';
import CssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker';
import HtmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker';
import TsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';
// import sqlWorker from 'monaco-editor/esm/vs/language/sql/sql.worker?worker'

// Configure Monaco workers
globalThis.MonacoEnvironment = {
  getWorker (_, label)
  {
    if (label === 'json') {
      return new JsonWorker();
    }
    if (label === 'css' || label === 'scss' || label === 'less') {
      return new CssWorker();
    }
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return new HtmlWorker();
    }
    if (label === 'ts' || label === 'typescript' || label === 'javascript') {
      return new TsWorker();
    }
    return new EditorWorker();
  },
};

// Erstatt den eksisterende app-initialiseringen med bootstrap-funksjonen
async function bootstrap ()
{
  try {
    // Bruk kun ny router
    const routerModule = await import('./router');

    // Hent router fra modulen
    const router = routerModule.default || routerModule.router;

    const app = createApp(App);
    app.use(createPinia());

    // Oppdater environment store ETTER Pinia er aktivert
    try {
      const config = await getEnvironmentVariables();
      updateEnvironmentStore(config);
      console.log('Environment store oppdatert');
    } catch (error) {
      console.warn('Kunne ikke oppdatere environment store:', error);
    }

    // Initialiser auth ETTER Pinia er satt opp, men før router brukes
    await initAuth();

    app.use(router);

    // Legg til alle eksisterende komponenter og biblioteker
    // Font-Awesome:
    library.add(
      faEquals, faNotEqual, faSearchMinus, faGreaterThanEqual, faLessThanEqual, faLessThan, faGreaterThan, faSearch, faClockRotateLeft,
      faTimes, faTrashCan, faTrashUndo, faFileCsv, faFileExcel, faFileLines, faFileImport, faDownToBracket, faBug, faBugSlash,
      faFile, faFileXls, faFileText, faFilePdf, faFileArchive, faFileCode, fadRotateRight, faFileExport, faFileDownload,
      faFileCircleExclamation, faFileZipper, faOctagonExclamation, faMagnifyingGlassChart, faFileMagnifyingGlass, faPlusCircle,
      faMinusCircle, faPlus, faMinus, falInfoCircle, faChartLine, faSpinner, faCheck, faAngleDown, faTable, faPencil, faPaperPlane,
      faInfinity, faFloppyDisk, faToggleLargeOn, faToggleLargeOff, faSliders, faCogs, faUser, faListDropdown, faRectangleList,
      faChartLineUp, faFolder, faChevronDown, faChevronLeft, faChevronRight, falChevronsLeft, falChevronsRight, faCog, faEye, faQuestionCircle, faHouse, faUpDownLeftRight, falArrowTurnDownRight,
      faArrowUp, faArrowDown, faSquare, faSquareCheck, faRotate, faColumns3, faDiagramProject, faCode, faPenField, faBookmark, faFolderClosed, faGripLines,
      faMemoCircleCheck, faMemoCircleInfo, faFolderOpen, faLayerPlus, faCodeCompare, faArrowRightArrowLeft, faCopy, faCircleCheck, faArrowLeft, falRotateRight,
      faBuilding, faSquareMinus, faTriangleExclamation, faEyeSlash,
      faArrowDownAZ, faBell, faPlay, faCircle, falCircleCheck, faPowerOff,
      faArrowDownZA, faFilter, faQuestion, faUsers, faFilterSlash, faListCheck, faList, faBox,
      falFolderOpen, faFolderCheck, faCabinetFiling, faFolderMagnifyingGlass, faUpFromBracket, faFileArrowUp, faUpRightFromSquare, faShieldHalved, faGlobe,
      faSquarePollHorizontal, faXmarkLarge, faArrowRight, faKeySkeleton, faRightLeftLarge, faHourglassHalf, faWandMagicSparkles,
      faBan, faDatabase, faDownload, faExclamationTriangle, faSave, faStar, faFileEdit, fasArrowTurnDownRight, fasInfoCircle, falEnvelope, faLock, faDiamondExclamation, faEllipsisV,
      faEllipsisStrokeVertical, faComments, faArrowDownWideShort, faArrowUpShortWide, fasStar,
    );
    app.component('FontAwesomeIcon', FontAwesomeIcon);
    app.component('FontAwesomeLayers', FontAwesomeLayers);

    // PrimeVue
    app.use(PrimeVue);

    // EDIT komponenter
    app.component('EditSimpleSelect', EditSimpleSelect);
    app.component('EditText', EditText);
    app.component('EditNumber', EditNumber);
    app.component('EditDate', EditDate);
    app.component('EditList', EditList);
    app.component('EditComment', EditComment);
    app.component('EditBool', EditBool);
    app.component('EditAutoComplete', EditAutoComplete);
    app.component('EditString', EditString);
    app.component('EditPercent', EditPercent);
    app.component('EditTime', EditTime);

    // MENU HEADERS
    app.component('hdrMenuAutoComplete', HdrMenuAutoComplete);
    app.component('hdrMenuBool', HdrMenuBool);
    app.component('hdrMenuList', HdrMenuList);
    app.component('hdrMenuText', HdrMenuText);
    app.component('hdrMenuSimpleSelect', HdrMenuSimpleSelect);
    app.component('hdrMenuDate', HdrMenuDate);
    app.component('hdrMenuNumber', HdrMenuNumber);
    app.component('hdrMenuString', HdrMenuString);
    app.component('hdrMenuComment', HdrMenuComment);
    app.component('hdrMenuTime', HdrMenuTime);
    app.component('hdrMenuPercent', HdrMenuPercent);

    app.mount('#app');
  } catch (error) {
    showCriticalError(error);
  }
}

// Start applikasjonen
try {
  await bootstrap();
} catch (error) {
  console.error(error);
}

// Funksjon for å vise feilmelding
function showCriticalError (error)
{
  console.error('Kritisk feil under initialisering:', error);

  const errorDiv = document.createElement('div');
  errorDiv.style.textAlign = 'center';
  errorDiv.style.margin = '50px auto';
  errorDiv.style.maxWidth = '500px';
  errorDiv.style.padding = '20px';
  errorDiv.style.border = '1px solid #f44336';
  errorDiv.style.borderRadius = '5px';
  errorDiv.style.backgroundColor = '#ffebee';

  errorDiv.innerHTML = `
    <h2 style="color: #d32f2f;">Kunne ikke starte applikasjonen</h2>
    <p>Det oppstod en feil under oppstart, klarte ikke laste konfigurasjon. Prøv å laste siden på nytt eller kontakt support.</p>
    <p style="font-size: 0.8em; color: #777; margin-top: 20px;">
      ${error.message || 'Ukjent feil'}
    </p>
    <button onclick="window.location.reload()"
            style="margin-top: 15px; padding: 8px 16px; background-color: #2196F3; color: white;
                   border: none; border-radius: 4px; cursor: pointer;">
      Last siden på nytt
    </button>
  `;

  document.body.appendChild(errorDiv);
}

// Global error handler for chunk loading
globalThis.addEventListener('error', (event) =>
{
  if (event.error && event.error.name === 'ChunkLoadError') {
    console.error('ChunkLoadError detected:', event.error);

    // Show user-friendly message
    const message = 'Kunne ikke laste en del av applikasjonen. Prøv å laste siden på nytt.';
    alert(message);

    // Optionally reload the page
    if (confirm('Vil du laste siden på nytt?')) {
      globalThis.location.reload();
    }
  }
});

// Handle unhandled promise rejections (which might include chunk loading failures)
globalThis.addEventListener('unhandledrejection', (event) =>
{
  if (event.reason && event.reason.name === 'ChunkLoadError') {
    console.error('Unhandled ChunkLoadError:', event.reason);
    event.preventDefault(); // Prevent default error handling

    const message = 'Kunne ikke laste en del av applikasjonen. Prøv å laste siden på nytt.';
    alert(message);

    if (confirm('Vil du laste siden på nytt?')) {
      globalThis.location.reload();
    }
  }
});
